export default __webpack_public_path__ + "static/media/submit-wallet-button.77e53bbf.svg";